import { css as _css } from "@emotion/react";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { useMemo } from 'react';
import { useWindowViewWidth } from '@arc/frontend/util-common';
const COL_WIDTH = 300;
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1m113pa",
  styles: "max-height:80vh;overflow-y:auto"
} : {
  name: "9mia1-DisplayArcGroupImportSuccess",
  styles: "max-height:80vh;overflow-y:auto;label:DisplayArcGroupImportSuccess;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function DisplayArcGroupImportSuccess(props) {
  const {
    import: arcGroupImport,
    t
  } = props;
  const width = useWindowViewWidth();
  const calcColumns = useMemo(() => {
    const dataLength = arcGroupImport?.newGroups?.length ?? 0;

    // Limit columns to screen width / 300px
    const columnsPossible = Math.ceil(width / COL_WIDTH);

    /**
     *   1 - 8 items: 1 column
     *  9 - 16 items: 2 columns
     * 17 - 24 items: 3 columns
     * etc.
     */
    const targetColumns = Math.ceil(dataLength / 8);

    // Use the smallest number of columns possible
    return Math.min(targetColumns, columnsPossible);
  }, [arcGroupImport?.newGroups?.length, width]);
  if (arcGroupImport?.status !== 'SUCCESS') {
    return null;
  }
  if (!arcGroupImport.newGroups?.length) {
    return <span>{t('deployments:Import groups success', {
        count: 0
      })}</span>;
  }
  return <div css={_ref}>
			<span>
				{t('deployments:Import groups success', {
        count: arcGroupImport.newGroups.length
      })}
			</span>
			<ul css={/*#__PURE__*/_css({
      listStyle: 'disc',
      marginTop: '8px',
      paddingLeft: '8px',
      columnCount: calcColumns,
      columnWidth: COL_WIDTH
    }, process.env.NODE_ENV === "production" ? "" : ";label:DisplayArcGroupImportSuccess;")}>
				{arcGroupImport.newGroups.map(group => <li key={group.id} css={/*#__PURE__*/_css({
        width: COL_WIDTH
      }, process.env.NODE_ENV === "production" ? "" : ";label:DisplayArcGroupImportSuccess;")}>
						{group.name}
					</li>)}
			</ul>
		</div>;
}